<script lang="ts">
    export let value: string;
    export let checked: boolean;
    export let onChange: (checked: boolean) => void;
</script>

<label class="Checkbox" class:Checkbox--checked={checked}>
    <input
        type="checkbox"
        {value}
        on:input={(e) => {
            onChange(e.currentTarget.checked);
        }}
        {checked}
    />
    <span class="label">
        <slot />
    </span>
</label>

<style type="text/scss">
    @import "../../../scss/config.scss";
    .Checkbox {
        span.label {
            position: relative;
            padding-left: 30px;
            &:before {
                content: "";
                width: 20px;
                height: 20px;
                border: 1px solid $color-medium-grey;
                border-radius: 2px;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
            }
        }
        :global(input[type="checkbox"]) {
            display: none;
        }
        &--checked {
            span.label {
                &:after {
                content: "";
                width: 16px;
                height: 16px;
                background: $color-primary;
                border-radius: 2px;
                display: block;
                position: absolute;
                top: 3px;
                left: 3px;
            }
            }
        }
    }
</style>
